import React from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';

const MenuCard = ({ menu, colors = {} }) => {
  // Default colors
  const defaultColors = {
    backgroundColor: '#f9fafb',
    borderColor: '#e5e7eb',
    titleColor: '#6b7280',
    headingColor: '#111827',
    textColor: '#374151',
    checkColor: '#10b981',
    priceOriginalColor: '#9ca3af',
    priceColor: '#111827',
    buttonBg: '#9333ea',
    buttonHover: '#7e22ce',
    buttonText: '#ffffff'
  };

  const finalColors = { ...defaultColors, ...colors };
  const promoData = menu.promo_data || {};

  return (
    <div 
      className="rounded-xl border p-4"
      style={{
        backgroundColor: finalColors.backgroundColor,
        borderColor: finalColors.borderColor
      }}
    >
      {/* Üst Başlık */}
      {promoData.upperTitle && (
        <div 
          className="text-xs mb-1"
          style={{ color: finalColors.titleColor }}
        >
          {promoData.upperTitle}
        </div>
      )}
      
      {/* Başlık */}
      <div 
        className="text-lg font-bold -mt-1 mb-2"
        style={{ color: finalColors.headingColor }}
      >
        {promoData.mainTitle || menu.title}
      </div>
      
      {/* Check Liste Öğeleri */}
      {promoData.features && Array.isArray(promoData.features) && promoData.features.length > 0 && (
        <ul className="space-y-1 mb-3">
          {promoData.features.map((feature, i) => (
            <li key={i} className="flex items-center text-sm" style={{ color: finalColors.textColor }}>
              <Check className="w-4 h-4 mr-2" style={{ color: finalColors.checkColor }} />
              {feature}
            </li>
          ))}
        </ul>
      )}
      
      {/* Fiyat Bilgileri */}
      {(promoData.priceOriginal || promoData.price) && (
        <div className="mb-3">
          {promoData.priceOriginal && (
            <div 
              className="text-xs mb-0.5 line-through"
              style={{ color: finalColors.priceOriginalColor }}
            >
              {promoData.priceOriginal}
            </div>
          )}
          {promoData.price && (
            <div 
              className="text-xl font-extrabold"
              style={{ color: finalColors.priceColor }}
            >
              {promoData.price}
            </div>
          )}
        </div>
      )}
      
      {/* Satın Al Button */}
      {(promoData.cta?.path || menu.url) && (
        <Link 
          to={promoData.cta?.path || menu.url} 
          className="mt-3 inline-flex items-center justify-center w-full text-white text-sm font-medium rounded-md h-9 transition-colors"
          style={{
            backgroundColor: finalColors.buttonBg
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = finalColors.buttonHover;
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = finalColors.buttonBg;
          }}
        >
          {promoData.cta?.label || 'Satın Al'}
        </Link>
      )}
    </div>
  );
};

export default MenuCard;



